import { User } from '../interface'
import { localGet, LocalKeysEnum } from './local'
export const getUser = (): User => {
    return localGet(LocalKeysEnum.TOKEN)
}
export const isMobile = () => {
    const regex_match = /(nokia|iphone|android|motorola|^mot-|softbank|foma|docomo|kddi|up.browser|up.link|htc|dopod|blazer|netfront|helio|hosin|huawei|novarra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte-|longcos|pantech|gionee|^sie-|portalmmm|jigs browser|hiptop|^benq|haier|^lct|operas*mobi|opera*mini|320x320|240x320|176x220)/i
    const u = navigator.userAgent
    if (null == u) {
        return true
    }
    const result = regex_match.exec(u)
    if (null == result) {
        return false
    } else {
        return true
    }

}
export const loadScript = (src:string)=> {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = src
        script.onload = function () {
            resolve(src)
        }
        script.onerror = function () {
            reject(new Error('Failed to load ' + src))
        }
        document.body.appendChild(script)
    })
}